import './bootstrap';
// The design system. Until now this file existed but was imported nowhere, and
// Tailwind came from a CDN script in index.html instead.
import '../css/app.css';
import { createRoot } from 'react-dom/client'
import Main from './Pages/main.jsx'

// Mount the React app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Main />);
